import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [
	{
        path: 'index',
        name: 'index',
        component: resolve => {
            require(['@/views/user/passport/login.vue'], resolve);
        },
        meta: {
            title: '用户登录'
        }
    },
    {
        path: 'assets/list',
        name: 'assetslist',
        component: resolve => {
            require(['@/views/user/assets/list.vue'], resolve);
        },
        meta: {
            title: '可用服务'
        }
    },
    {
        path: 'assets/coupon',
        name: 'assetsCoupon',
        component: resolve => {
            require(['@/views/user/assets/coupon.vue'], resolve);
        },
        meta: {
            title: '优惠券'
        }
    },
    {
        path: 'assets/activation',
        name: 'assetsActivation',
        component: resolve => {
            require(['@/views/user/assets/activation.vue'], resolve);
        },
        meta: {
            title: '激活卡券'
        }
    },
    {
        path: 'assets/message',
        name: 'assetsMessage',
        component: resolve => {
            require(['@/views/user/assets/message.vue'], resolve);
        },
        meta: {
            title: '激活跳转页'
        }
    },
    {
        path: 'booked/homecareBookedList',
        name: 'bookedHomecareBookedList',
        component: resolve => {
            require(['@/views/user/booked/homecareBookedList.vue'], resolve);
        },
        meta: {
            title: '医护上门列表页'
        }
    },
    {
        path: 'booked/homecareBookedDetail/:id',
        name: 'bookedHomecareBookedDetail',
        component: resolve => {
            require(['@/views/user/booked/homecareBookedDetail.vue'], resolve);
        },
        meta: {
            title: '医护上门列表详情页'
        }
    },
    {
		path: 'address/list',
		name: 'addressList',
		component: resolve => {
		  require(['@/views/user/address/list.vue'], resolve);
		},
		meta:{
		  title:'联系地址'
		}
	},
	{
		path: 'address/form',
		name: 'form',
		component: resolve => {
		  require(['@/views/user/address/form.vue'], resolve);
		},
		meta:{
		  title:'地址管理'
		}
  }	
]

let route = [{
    path: '/user',
    component: CommomProxy,
    children: child_routes
}]

export default route



// WEBPACK FOOTER //
// ./src/router/user.js